import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export const uploadImage = createAsyncThunk(
    'dietPlan/uploadImage',
    async (file, { rejectWithValue }) => {
      const formData = new FormData();
      formData.append('file', file);
  
      try {
        const response = await axios.post(
          'http://95.111.225.198:8082/usersApi/api/documents/uploadFILE',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            }
          }
        );
        
        return response.data.data; // Retourne les données de la réponse (id, fileName, fileUrl, etc.)
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Erreur lors du téléchargement du fichier.');
      }
    }
  );